/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import {
	createResource,
	type RouterContext,
	type RouteResource,
} from '@atlassian/react-resource-router';
import { RESOURCE_TYPE_RAPIDBOARDS_WRM_BUNDLE } from './resourceTypeRapidboardsWrmBundle.constants.tsx';
import { getRapidViewConfigFromRouteName } from './getRequiredResourceList.tsx';

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const wrmBundleResource: RouteResource<any> = createResource<any>({
	type: RESOURCE_TYPE_RAPIDBOARDS_WRM_BUNDLE,
	getKey: ({ route }: RouterContext) => getRapidViewConfigFromRouteName(route.name).stateKey,
	getDataLoader: () =>
		import(
			/* webpackChunkName: "async-resource-rapidboards-wrm-bundle", jiraSpaEntry: "async-resource-rapidboards-wrm-bundle" */ './RapidBoardWrmBundleResourceType.tsx'
		),
	maxAge: Number.MAX_SAFE_INTEGER,
	isBrowserOnly: true,
});
